/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {
  SystemNamesEnum,
  WorkflowExternalStepDefDtoModel,
  WorkflowUiDefinitionModel
} from "@well/iriro-frontend-libs/workflows/domain";
import {DefinitionsNameEnum} from "./DefinitionsName.enum";

class CustomETransportUploadDefinition implements WorkflowUiDefinitionModel {
  configuredBy= null;
  configuredForOwner= false;
  defaultLabel= null
  name= DefinitionsNameEnum.CUSTOM_ETRANSPORT_UPLOAD
  systemName= SystemNamesEnum.ANGULAR_FRONTEND
  definitionFile= 'custom_etransport_upload_definition'
  uiSteps = {
    displayCustomETransportUpload: WorkflowExternalStepDefDtoModel.createWorkflowStepVoModel("SHOW_CUSTOM_ETRANSPORT_UPLOAD" , SystemNamesEnum.ANGULAR_FRONTEND),
  }
  uuid= null
  valid= null
  validFrom= null
  validTo= null
}

export const customETransportUploadDefinition = new CustomETransportUploadDefinition();

